import { Input } from "antd";
import classNames from "classnames";
import PropTypes from "prop-types";
import Label from "../Label";

const { TextArea } = Input;

const Textarea = ({
  label,
  placeholder,
  errors,
  touched,
  icon,
  required,
  optional,
  direction,
  ...rest
}) => (
  <div
    className={classNames(
      "acoris__input",
      { "acoris__input--error": touched && errors },
      { "acoris__input--valid": touched && !errors },
      direction,
    )}
  >
    <Label label={label} icon={icon} required={required} optional={optional} />
    <div className="acoris__input--field">
      <TextArea
        className={classNames({
          "disable--input": rest.disabled,
        })}
        placeholder={placeholder}
        {...rest}
      />
      {touched && errors && <p className="input--errors">{errors}</p>}
    </div>
  </div>
);

Textarea.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  errors: PropTypes.string,
  touched: PropTypes.bool,
  icon: PropTypes.node,
};

Textarea.defaultProps = {
  label: "",
  placeholder: "",
};

export default Textarea;
